export default __webpack_public_path__ + "media/images/missing_male_big-c2dbebb12c986f8e5e217716a15e2561.png";